import axios from 'axios';
import { SCTK_SERVICE_URL } from '../Common/Constant/API';
import { commonRequestHeaders } from '../Common/request/headers';

const API_BASE = SCTK_SERVICE_URL;

const authHeader = () =>
  localStorage.getItem('token') ? { Authorization: `Bearer ${localStorage.getItem('token')}` } : {};
const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const s = String(r.result || '');
      // r.result looks like: "data:application/json;base64,AAAA..."
      const idx = s.indexOf('base64,');
      resolve(idx >= 0 ? s.slice(idx + 'base64,'.length) : s);
    };
    r.onerror = reject;
    r.readAsDataURL(file);
  });

export const addExtension = (payload) =>
  axios.post(`${API_BASE}/addExtension`, payload, {
    headers: {
      'Content-Type': 'application/json',
      ...commonRequestHeaders(),
      ...authHeader(),
    },
  });

export const generateFlatSwagger = (payload) =>
  axios.post(`${API_BASE}/generateFlatSwaggerWithExtensions`, payload, {
    headers: {
      'Content-Type': 'application/json',
      ...commonRequestHeaders(),
      ...authHeader(),
    },
    responseType: 'blob',
  });

export const validateSwaggerFile = async (key, market, file) => {
  const base64 = await fileToBase64(file);
  const payload = {
    key,
    market,
    generateMarkDown: 'false', // keep your existing flag behavior
    name: file.name,
    base64Content: base64,
  };
  return axios.post(`${API_BASE}/checkFile`, payload, {
    headers: {
      'Content-Type': 'application/json',
      ...commonRequestHeaders(),
      ...authHeader(),
    },
  });
};

export const compareSwaggerFiles = async (officialFile, editedFile, outputFormat = 'JSON') => {
  const [base64ContentA, base64ContentB] = await Promise.all([fileToBase64(officialFile), fileToBase64(editedFile)]);

  return axios.post(
    `${API_BASE}/compareSwaggerFiles`,
    {
      nameA: officialFile.name,
      base64ContentA,
      nameB: editedFile.name,
      base64ContentB,
      outputFormat,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...commonRequestHeaders(),
        ...authHeader(),
      },
    },
  );
};

export const validateSwagger = async (file) => {
  const base64Content = await fileToBase64(file);
  return axios.post(
    `${API_BASE}/validateSwagger`,
    {
      name: file.name,
      base64Content,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...commonRequestHeaders(),
        ...authHeader(),
      },
    },
  );
};
